{
    "accept": "Accettare",
    "all": "Tutti",
    "back": "Indietro",
    "cancel": "Annulla",
    "choose": "Scegli",
    "client_offline_error_description": "Sei offline. Controlla la tua connessione Internet e riprova.",
    "client_timeout_error_description": "Non siamo riusciti a completare la tua richiesta a causa di un timeout della connessione. Controlla la tua connessione e riprova. Se il problema persiste, il nostro team di supporto è a tua disposizione.",
    "delete": "Cancella",
    "description": "Descrizione",
    "dismiss": "Abbandona",
    "done": "Fatto",
    "donor_feedback_anonymized": "Abbiamo già reso anonimi i tuoi dati per motivi di protezione dei dati.",
    "donor_feedback_incorrect_link": "Il link che stai utilizzando non è corretto - assicurati di utilizzare il link completo che ti è stato inviato.",
    "donor_feedback_not_found": "Sfortunatamente, questo link non è valido per uno dei seguenti motivi:",
    "error_occurred": "Si è verificato un errore",
    "expired": "Scaduto",
    "failed": "non riuscito/a",
    "field_error_address_unsupported_country": "Indirizzo in paese non riconosciuto",
    "field_error_any": "Inserisci almeno uno di questi campi: ${1}",
    "field_error_date_invalid": "Indica una data valida",
    "field_error_date_max": "La data deve essere ${1} o precedente",
    "field_error_date_min": "La data deve essere ${1} o successiva",
    "field_error_date_range_max": "La data deve essere precedente a ${1}",
    "field_error_date_range_min": "La data deve essere successiva a ${1}",
    "field_error_email": "Indica un'e-mail valida",
    "field_error_length_max": "Questo campo è limitato a ${1} caratteri",
    "field_error_length_min": "Indica un minimo di ${1} caratteri",
    "field_error_max": "Il valore massimo è ${1}",
    "field_error_min": "Il valore minimo è ${1}",
    "field_error_pattern": "L'input non è valido",
    "field_error_phone_invalid": "Indica un numero di telefono valido",
    "field_error_phone_starts_with_zero": "Esiste già un codice paese. Eliminare lo \"0\" iniziale dal numero di telefono.",
    "field_error_required": "Compila questo campo",
    "field_is_required": "Questo campo è obbligatorio",
    "field_placeholder_address_search": "Inserisci una postazione",
    "field_select_not_found": "'${1}' non è stato trovato",
    "font_big": "carattere grande",
    "font_medium": "carattere medio",
    "font_small": "carattere piccolo",
    "last_attempt": "Ultimo tentativo",
    "last_upload": "Ultimo caricamento",
    "link_sent": "Link inviato, verifica",
    "network_error": "Errore di rete",
    "network_error_cookies_disabled_description": "Sembra che tu abbia disattivato tutti i cookie. Prova eventualmente con un altro browser.",
    "next": "Successivo",
    "no_results": "Nessun risultato",
    "offline": "offline",
    "ok": "OK",
    "online": "online",
    "open": "Apri",
    "page_not_found_description": "La pagina che hai provato a richiedere non esiste. Potresti aver digitato male l'URL.",
    "page_not_found_link": "Torna alla homepage.",
    "page_not_found_title": "Pagina non trovata",
    "passed": "superato",
    "request_support": "Richiedi supporto",
    "request_support_success_description": "Abbiamo ricevuto la tua richiesta di supporto.",
    "result": "Risultato",
    "retry": "Riprova",
    "save": "Salva",
    "send_a_support_request": "Richiesta di supporto",
    "state_done": "Fatto",
    "state_not_uploaded": "Non caricato",
    "state_pending": "In attesa",
    "state_refused": "Rifiutato",
    "state_uploading": "Caricamento",
    "submit": "Invia",
    "support_request_type": "Tipo di problema",
    "support_request_type_crash": "Crash",
    "support_request_type_critical": "Critico",
    "support_request_type_minor": "Minore",
    "support_request_type_other": "Altro",
    "type": "Tipo",
    "uploading": "Caricamento in corso..."
}